import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { FormControl, InputLabel, Menu, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  transactionTypeDetailInvoice,
  transactionTypeDetailOther,
  transactionTypeDetailPurchaseOrder,
  transactionTypeDetailSalesOrder,
  transactionTypeDetailBill,
  transactionTypeCreditMemo,
  transactionJournalTable,
  transactionDepositTable,
  transactionRevenueArrangementTable,
  transactionTypeCustom,
  transactionTypeBillPayment,
  transactionTypeBillCreditTable,
  transactionTypeCreditCardTable,
  transactionTypeCashsaleDetails,
  transactionTypeCheck,
  transactionTypeItemFullfillmenttable,
} from "../../config/grid-column-defs";
import {
  getTransactionTypeDetail,
  getTransactionTypeDetailExcelData,
  getTransactionTypesap_check,
  getTransactionTypesap_checkExcelData,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isAfter, isToday } from "date-fns";
import { saveAs } from "file-saver";
import AgGridPaginatedPageNumberSearchTable from "../../components/AgGridPaginatedPageNumberSearchTable";
import { getSubsidiary } from "../../api/accounts";

export default function TransactionTypeDetails() {
  const [anchorEl, setAnchorEl] = useState(null);
  const dateRef = useRef();
  const idRef = useRef();
  const docuRef = useRef();
  const postingRef = useRef();
  const customerRef = useRef();
  const subsidiaryRef = useRef();
  const pcProjectRef = useRef();
  const vendorRef = useRef();
  const reqByRef = useRef();
  const expTypeRef = useRef();
  const statusRef = useRef();
  const accountRef = useRef();
  const [pcProjectChecked, setPcProjectChecked] = useState(false);
  const [ExpTypeChecked, setExpTypeChecked] = useState(false);
  const [ExpAccountChecked, setExpAccountChecked] = useState(false);
  const [ReqByChecked, setReqByChecked] = useState(false);
  const [dateSortAscending, setDateSortAscending] = useState(true);
  const [docSortAscending, setDocSortAscending] = useState(true);
  const [dateChecked, setDateChecked] = useState(false);
  const [MemoChecked, setMemoChecked] = useState(false);
  const [docuChecked, setdocuChecked] = useState(false);
  const [idChecked, setidChecked] = useState(false);
  const [customerChecked, setCustomerChecked] = useState(false);
  const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
  const [poCheckNumberChecked, setPoCheckNumberChecked] = useState(false);
  const [vendorChecked, setVendorChecked] = useState(false);
  const [currencyChecked, setCurrencyChecked] = useState(false);
  const [accountChecked, setAccountChecked] = useState(false);
  const [postingChecked, setPostingChecked] = useState(false);
  const [statusChecked, setStatusChecked] = useState(false);

  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [onInputSearch, setInputSearch] = useState();
  const [searchInputValue, setSearchValue] = useState("");
  const [date_For_validation, setDate_validation] = useState({});
  const params = useParams();
  //console.log(params.slug);
  const pageDetail = slugMap[params.slug] ? slugMap[params.slug] : params.slug;
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [totalSum, setTotalSum] = useState("");
  // date //

  const today = new Date();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [documentNoSearchInputValue, setDocumentNoSearchValue] = useState("");
  const [memoSearchInputValue, setMemoSearchValue] = useState("");
  const [viewIdSearchInputValue, setViewIdSearchInputValue] = useState("");
  const [IdSearchInputValue, setIdSearchInputValue] = useState("");
  const [pc_projectInputValue, setPcProjectInputValue] = useState("");
  const [expense_accountInputValue, setExpenseAccountInputValue] = useState("");
  const [expense_typeInputValue, setExpenseTypeInputValue] = useState("");
  const [requested_byInputValue, setRequestedByInputValue] = useState("");
  const [customerSearchInputValue, setCustomerSearchInputValue] = useState("");
  const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] =
    useState("");
  const [poCheckNumberSearchInputValue, setPoCheckNumberSearchInputValue] =
    useState("");
  const [vendorSearchInputValue, setVendorSearchInputValue] = useState("");
  const [statusSearchInputValue, setStatusSearchInputValue] = useState("");
  const [currencySearchInputValue, setCurrencySearchInputValue] = useState("");
  const [accountSearchInputValue, setAccountSearchInputValue] = useState("");
  const [postingSearchInputValue, setPostingSearchInputValue] = useState("");
  const [subsdiaryRowData, setSubsidiaryRowData] = useState([]);
  const [sortByDocNo, setSortBySortNo] = useState("");
  // date  //

  const [error, setError] = useState("");
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };

  async function getTransactionTypeDetailTableData(limit, offset) {
    let fl = {
      ...onInputSearch,
      sortbyDate: onInputSearch?.sortbyDate || "desc",
    };
    try {
      const { data } =
        params?.slug === "custom"
          ? await getTransactionTypesap_check(
              user?.token,
              onInputSearch
                ? {
                    limit,
                    offset,
                    ...onInputSearch,
                  }
                : {
                    limit,
                    offset,
                  }
            )
          : await getTransactionTypeDetail(
              user?.token,
              fl
                ? {
                    limit,
                    offset,
                    // sortbyDocno: docSortAscending ? "desc" : "asc",
                    type: pageDetail.path ? pageDetail.path : pageDetail,
                    ...fl,
                  }
                : {
                    limit,
                    offset,
                    sortbyDate: dateSortAscending ? "desc" : "asc",
                    // sortbyDocno: docSortAscending ? "desc" : "asc",
                    type: pageDetail.path ? pageDetail.path : pageDetail,
                  }
            );
      setTotalSum(data.totalSum);
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  const onDocumentNoInputSearch = (event) => {
    setDocumentNoSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, documentno: event.target.value });
  };
  const onMemoInputSearch = (event) => {
    setMemoSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, memo: event.target.value });
  };
  const onViewIdInputSearch = (event) => {
    setViewIdSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, internalid: event.target.value });
  };
  const onIdInputSearch = (event) => {
    setIdSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, documentno: event.target.value });
  };
  const onStatusInputSearch = (event) => {
    setStatusSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, status: event.target.value });
  };
  const onCustomerInputSearch = (event) => {
    setCustomerSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, name: event.target.value });
  };
  const onSubsidiaryInputSearch = (event) => {
    setSubsidiarySearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, subsidiary_name: event.target.value });
  };
  const onCustomSubsidiaryInputSearch = (event) => {
    setSubsidiarySearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, subsidiary: event.target.value });
  };
  const onPoCheckNumberInputSearch = (event) => {
    setPoCheckNumberSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, po_check_number: event.target.value });
  };
  const onVendorInputSearch = (event) => {
    setVendorSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, name: event.target.value });
  };
  const onVendorNameInputSearch = (event) => {
    setVendorSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, vendor_name: event.target.value });
  };
  const onPcProjectInputSearch = (event) => {
    setPcProjectInputValue(event.target.value);

    setInputSearch({ ...onInputSearch, pc_project: event.target.value });
  };
  const onExpTypeInputSearch = (event) => {
    setExpenseTypeInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, expense_type: event.target.value });
  };
  const onReqByInputSearch = (event) => {
    setRequestedByInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, requested_by: event.target.value });
  };
  const onCurrencyInputSearch = (event) => {
    setCurrencySearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, currency: event.target.value });
  };
  const onAccountInputSearch = (event) => {
    setAccountSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, account: event.target.value });
  };
  const onPostingInputSearch = (event) => {
    setPostingSearchInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, posting: event.target.value });
  };
  const onExpenseAccountInputSearch = (event) => {
    setExpenseAccountInputValue(event.target.value);
    setInputSearch({ ...onInputSearch, expense_account: event.target.value });
  };
  const handleClose1 = (event) => {
    if (event.target.name === "memo") {
      setMemoChecked(event.target.checked);
      setMemoSearchValue("");
      setInputSearch({ ...onInputSearch, memo: "" });
    }
    
    if (event.target.name === "status") {
      setStatusChecked(event.target.checked);
      setStatusSearchInputValue("");
      setInputSearch({ ...onInputSearch, status: "" });
    }
    if (event.target.name === "expense_account") {
      setExpAccountChecked(event.target.checked);
      setExpenseAccountInputValue("");
      setInputSearch({ ...onInputSearch, expense_account: "" });
    }
    if (event.target.name === "date") {
      setDateChecked(event.target.checked);
      setStartDate("");
      setEndDate("");
      setInputSearch({ ...onInputSearch, datefrom: "", dateto: "" });
    }
    if (event.target.name === "documentno") {
      setdocuChecked(event.target.checked);
      setDocumentNoSearchValue("");
      setInputSearch({ ...onInputSearch, documentno: "" });
    }
    if (event.target.name === "internalid") {
      setidChecked(event.target.checked);
      setViewIdSearchInputValue("");
      setInputSearch({ ...onInputSearch, internalid: "" });
    }
    if (event.target.name === "name") {
      setCustomerChecked(event.target.checked);
      setCustomerSearchInputValue("");
      setInputSearch({ ...onInputSearch, name: "" });
    }
    if (event.target.name === "subsidiary_name") {
      setSubsidiaryChecked(event.target.checked);
      setSubsidiarySearchInputValue("");
      setInputSearch({ ...onInputSearch, subsidiary_name: "" });
    }
    if (event.target.name === "subsidiary") {
      setSubsidiaryChecked(event.target.checked);
      setSubsidiarySearchInputValue("");
      setInputSearch({ ...onInputSearch, subsidiary: "" });
    }
    if (event.target.name === "po_check_number") {
      setPoCheckNumberChecked(event.target.checked);
      setPoCheckNumberSearchInputValue("");
      setInputSearch({ ...onInputSearch, po_check_number: "" });
    }
    if (event.target.name === "vendor") {
      setVendorChecked(event.target.checked);
      setVendorSearchInputValue("");
      setInputSearch({ ...onInputSearch, name: "" });
    }
    if (event.target.name === "currency") {
      setCurrencyChecked(event.target.checked);
      setCurrencySearchInputValue("");
      setInputSearch({ ...onInputSearch, currency: "" });
    }
    if (event.target.name === "account") {
      setAccountChecked(event.target.checked);
      setAccountSearchInputValue("");
      setInputSearch({ ...onInputSearch, account: "" });
    }
    if (event.target.name === "posting") {
      setPostingChecked(event.target.checked);
      setPostingSearchInputValue("");
      setInputSearch({ ...onInputSearch, posting: "" });
    }
    if (event.target.name === "id") {
      setidChecked(event.target.checked);
      setIdSearchInputValue("");
      setInputSearch({ ...onInputSearch, documentno: "" });
    }
    if (event.target.name === "vendor_name") {
      setVendorChecked(event.target.checked);
      setVendorSearchInputValue("");
      setInputSearch({ ...onInputSearch, vendor_name: "" });
    }
    if (event.target.name === "pc_project") {
      setPcProjectChecked(event.target.checked);
      setPcProjectInputValue("");
      setInputSearch({ ...onInputSearch, pc_project: "" });
    }
    if (event.target.name === "expense_type") {
      setExpTypeChecked(event.target.checked);
      setExpenseTypeInputValue("");
      setInputSearch({ ...onInputSearch, expense_type: "" });
    }
    if (event.target.name === "requested_by") {
      setReqByChecked(event.target.checked);
      setRequestedByInputValue("");
      setInputSearch({ ...onInputSearch, requested_by: "" });
    }
    setAnchorEl(null);
  };

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  useEffect(() => {
    setInputSearch();
    setSearchValue("");
    handleClickReset();
  }, [params.slug]);

  const handleClickReset = (event) => {
    setInputSearch();
    setSearchValue("");
    setStartDate("");
    setEndDate("");
    setAnchorEl(null);
    setDateChecked(dateChecked ? false : false);
    setMemoChecked(MemoChecked ? false : false);
    setdocuChecked(false);
    setidChecked(false);
    setCustomerChecked(false);
    setSubsidiaryChecked(false);
    setPoCheckNumberChecked(false);
    setVendorChecked(false);
    setCurrencyChecked(false);
    setAccountChecked(false);
    setPostingChecked(false);
    setIdSearchInputValue("");
    setPcProjectChecked(false);
    setExpTypeChecked(false);
    setReqByChecked(false);
    setStatusChecked(false)
    setStatusSearchInputValue("")

  };

  const onSortChanged = (event) => {
    const allColumns = event.columnApi.getAllColumns();
    const sortedColumns = event.columnApi
      .getAllColumns()
      .filter((col) => col.getSort());
    console.log(sortedColumns, "ons");
    if (sortedColumns[0].colId === "date") {
      setInputSearch({
        ...onInputSearch,
        [sortedColumns[0].colId === "date"
          ? "sortbyDate"
          : sortedColumns[0].colId]: sortedColumns[0].sort,
        sortbyDocno: "",
      });
      return;
    }
    if (
      sortedColumns[0].colId === "documentno" ||
      sortedColumns[0].colId === "documentno_1"
    ) {
      setInputSearch({
        ...onInputSearch,
        [sortedColumns[0].colId === "date" ? "sortbyDate" : "sortbyDocno"]:
          sortedColumns[0].sort,
        sortbyDate: "desc",
      });
      return;
    }
    setInputSearch({ ...onInputSearch, sortbyDocno: "", sortbyDate: "desc" });
  };
  function onDocSortChanged() {
    setDocSortAscending((previous) => !previous);
    setTableRefreshCount((prev) => prev + 1);
  }
  function isStringInteger(value) {
    return (
      Number.isInteger(parseInt(value)) && value === parseInt(value).toString()
    );
  }

  const InputSearch = (event) => {
    if (isStringInteger(event.target.value) || docuChecked) {
      setInputSearch({ ...onInputSearch, documentno: event.target.value });
      setSearchValue(event.target.value);
    } else if (event.target.value.includes("/")) {
      setInputSearch({ ...onInputSearch, datefrom: event.target.value });
    } else if (MemoChecked) {
      setInputSearch({ ...onInputSearch, memo: event.target.value });
    }
    if (
      !MemoChecked &&
      !docuChecked &&
      !idChecked &&
      !dateChecked &&
      !subsidiaryChecked &&
      !poCheckNumberChecked &&
      !vendorChecked &&
      !currencyChecked &&
      !accountChecked &&
      !postingChecked &&
      !pcProjectChecked &&
      !ExpTypeChecked &&
      !ReqByChecked
    ) {
      setInputSearch({ ...onInputSearch, documentno: event.target.value });
      setSearchValue(event.target.value);
    }

    if (!event.target.value.includes("-")) {
      setSearchValue(event.target.value);
    }
  };
  const onApInputSearch = (event) => {
    if (isStringInteger(event.target.value) || docuChecked) {
      setInputSearch({ ...onInputSearch, documentno: event.target.value });
      setSearchValue(event.target.value);
    } else if (event.target.value.includes("/")) {
      setInputSearch({ ...onInputSearch, datefrom: event.target.value });
    } else if (MemoChecked) {
      setInputSearch({ ...onInputSearch, memo: event.target.value });
    }
    if (
      !idChecked &&
      !dateChecked &&
      !subsidiaryChecked &&
      !vendorChecked &&
      !accountChecked &&
      !postingChecked &&
      !pcProjectChecked &&
      !ExpTypeChecked &&
      !ReqByChecked
    ) {
      setInputSearch({ ...onInputSearch, documentno: event.target.value });
      setSearchValue(event.target.value);
    }

    if (!event.target.value.includes("-")) {
      setSearchValue(event.target.value);
    }
  };

  const handleStartDateChange = (date) => {
    if (isAfter(date, today)) {
      // If the selected start date is after today, do not update the state
      return;
    }
    setStartDate(date);
    setInputSearch({
      ...onInputSearch,

      datefrom: format(date, "MM/dd/yyyy"),
    });
    // Ensure that the selected start date is always older than the end date
    if (endDate && isAfter(date, endDate)) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    if (isAfter(date, today)) {
      // If the selected end date is after today, do not update the state
      return;
    }

    // Ensure that the selected end date is always after the start date
    if (startDate && isAfter(startDate, date)) {
      return;
    }
    setInputSearch({
      ...onInputSearch,

      dateto: format(date, "MM/dd/yyyy"),
    });
    setEndDate(date);
  };
  const [exportLoading, setExportLoading] = useState(false);
  const exportData = async (e) => {
    e.preventDefault();
    let fl = {
      ...onInputSearch,
      sortbyDate: onInputSearch?.sortbyDate || "desc",
    };
    setExportLoading(true);
    {
      params?.slug === "custom"
        ? await getTransactionTypesap_checkExcelData(
            user?.token,
            onInputSearch
              ? {
                  ...onInputSearch,
                  exporttoexcel: "xlsx",
                   limit:"",
                 offset: 0,
                }
              : {
                  exporttoexcel: "xlsx",
                   limit:"",
                 offset: 0,
                }
          )
        : await getTransactionTypeDetailExcelData(
            user?.token,
            fl
              ? {
                  // sortbyDocno: docSortAscending ? "desc" : "asc",
                  type: pageDetail.path ? pageDetail.path : pageDetail,
                  ...fl,
                  exporttoexcel: "xlsx",
                }
              : {
                  sortbyDate: dateSortAscending ? "desc" : "asc",
                  // sortbyDocno: docSortAscending ? "desc" : "asc",
                  type: pageDetail.path ? pageDetail.path : pageDetail,
                  exporttoexcel: "xlsx",
                }
          )
            .then((blob) => {
              setExportLoading(false);

              const blb = new Blob([blob.data], { type: "text/csv" });
              saveAs(blb, `${params.slug}_${format(today, "MM/dd/yyyy")}.csv`);
            })
            .catch((error) => {
              setExportLoading(false);

              snackbar.showError("File does not exist");
            });
    }
    // const blob = new Blob([data],{ type: 'text/csv' });
    // saveAs(blob, 'table_records.csv');
  };

  useEffect(() => {
    if (user.token) {
      getSubsidiaryData();
    }
  }, [user.token]);
  async function getSubsidiaryData() {
    try {
      const { data } = await getSubsidiary(user.token, {});
      setSubsidiaryRowData(data?.data);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
    } finally {
      // setLoading(false)
    }
  }
  console.log(pageDetail, "pageDetail");
  return (
    <>
      <Paper sx={{ borderRadius: "8px", border: "1px solid #1615131a;" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          p={1}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            {pageDetail?.title || "Details"}
          </Typography>
          {/*  <Link to="/transaction-type">
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>*/}
          <Button
            disabled={exportLoading}
            type="button"
            onClick={(e) => exportData(e)}
          >
            {exportLoading ? "Please wait..!" : "Export"}
          </Button>
        </Box>

        <Box className="totalAmountStyle">
          {/* <Typography>{"Total Amount:" + totalSum}</Typography> */}
        </Box>

        <Box className="filter-box">
          <Grid container alignItems="center">
            <Grid item md={12} sm={12} xs={12}>
              {params?.slug === "custom" ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Grid container alignItems="center" variant="scrollable">
                    <Grid item md={1} sm={1} xs={1}>
                      <Button
                        id="basic-button1"
                        sx={{ color: "black", fontWeight: "600" }}
                        aria-controls={open1 ? "basic-menu1" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open1 ? "true" : undefined}
                        onClick={handleClick1}
                      >
                        <SearchIcon /> <KeyboardArrowDownIcon />
                      </Button>

                      <Menu
                        id="basic-menu1"
                        anchorEl={anchorEl}
                        open={open1}
                        MenuListProps={{
                          "aria-labelledby": "basic-button1",
                          style: {
                            maxHeight: "250px",
                            overflowY: "auto",
                          },
                        }}
                      >
                        <MenuItem>
                          <Checkbox
                            name="vendor_name"
                            checked={vendorChecked}
                            ref={vendorRef}
                            onClick={handleClose1}
                          />
                          Vendor Name
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              width: "100%",
                              position: "relative",
                              top: "-16px",
                              left: "5px",
                            }}
                          >
                            <svg
                              onClick={handleClose1}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              height={25}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </Box>
                        </MenuItem>

                        <MenuItem>
                          <Checkbox
                            name="date"
                            checked={dateChecked}
                            ref={dateRef}
                            onClick={handleClose1}
                          />
                          Date
                        </MenuItem>
                        <MenuItem>
                          <Checkbox
                            name="subsidiary"
                            checked={subsidiaryChecked}
                            ref={subsidiaryRef}
                            onClick={handleClose1}
                          />
                          Subsidiary Name
                        </MenuItem>
                        <MenuItem>
                          <Checkbox
                            name="pc_project"
                            checked={pcProjectChecked}
                            ref={pcProjectRef}
                            onClick={handleClose1}
                          />
                          Pc/Project
                        </MenuItem>
                        <MenuItem>
                          <Checkbox
                            name="expense_type"
                            checked={ExpTypeChecked}
                            ref={expTypeRef}
                            onClick={handleClose1}
                          />
                          Expense Type
                        </MenuItem>
                        <MenuItem>
                          <Checkbox
                            name="requested_by"
                            checked={ReqByChecked}
                            ref={reqByRef}
                            onClick={handleClose1}
                          />
                          Requested By
                        </MenuItem>
                      </Menu>
                    </Grid>
                    <Grid
                      item
                      md={11}
                      sm={11}
                      xs={11}
                      alignItems="center"
                      display="flex"
                      flexWrap="wrap"
                    >
                      {dateChecked && (
                        <>
                          <Box
                            style={{
                              display: "flex",
                              gap: "5px",
                              justifyItems: "center",
                              alignItems: "center",
                              marginRight: "8px",
                            }}
                          >
                            <div>
                              <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                                maxDate={today}
                                showIcon
                                showYearDropdown
                              />
                            </div>
                            to
                            <div>
                              <DatePicker
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                                maxDate={today}
                                showIcon
                                showYearDropdown
                              />
                            </div>
                          </Box>
                        </>
                      )}
                      {!dateChecked &&
                        !customerChecked &&
                        !subsidiaryChecked &&
                        !ReqByChecked &&
                        !pcProjectChecked &&
                        !ExpTypeChecked &&
                        !ReqByChecked &&
                        !vendorChecked && (
                          <TextField
                            autoComplete="off"
                            type={dateChecked ? "date" : ""}
                            id="outlined-basic"
                            placeholder=""
                            size="small"
                            label="Search ID"
                            name={dateChecked ? "datefrom" : ""}
                            variant="outlined"
                            value={searchInputValue}
                            onChange={onApInputSearch}
                            sx={{ pr: 1 }}
                          />
                        )}
                      {pcProjectChecked && (
                        <TextField
                          autoComplete="off"
                          placeholder={`${
                            pcProjectChecked ? "Search Pc/Project" : ""
                          }`}
                          size="small"
                          label=""
                          name={pcProjectChecked ? "id" : ""}
                          variant="outlined"
                          value={pc_projectInputValue}
                          onChange={onPcProjectInputSearch}
                          style={{ marginTop: "4px", marginBottom: "4px" }}
                          sx={{ pr: 1 }}
                        />
                      )}
                      {ExpTypeChecked && (
                        <TextField
                          autoComplete="off"
                          placeholder={`${
                            ExpTypeChecked ? "Search Expense Type" : ""
                          }`}
                          size="small"
                          label=""
                          name={ExpTypeChecked ? "id" : ""}
                          variant="outlined"
                          value={expense_typeInputValue}
                          onChange={onExpTypeInputSearch}
                          style={{ marginTop: "4px", marginBottom: "4px" }}
                          sx={{ pr: 1 }}
                        />
                      )}
                      {ReqByChecked && (
                        <TextField
                          autoComplete="off"
                          placeholder={`${
                            ReqByChecked ? "Search Requested By" : ""
                          }`}
                          size="small"
                          label=""
                          name={ReqByChecked ? "id" : ""}
                          variant="outlined"
                          value={requested_byInputValue}
                          onChange={onReqByInputSearch}
                          style={{ marginTop: "4px", marginBottom: "4px" }}
                          sx={{ pr: 1 }}
                        />
                      )}
                      {vendorChecked && (
                        <TextField
                          autoComplete="off"
                          placeholder={`${vendorChecked ? "Vendor Name" : ""}`}
                          size="small"
                          label=""
                          name={vendorChecked ? "vendor" : ""}
                          variant="outlined"
                          value={vendorSearchInputValue}
                          onChange={onVendorNameInputSearch}
                          style={{ marginTop: "4px", marginBottom: "4px" }}
                          sx={{ pr: 1 }}
                        />
                      )}
                      {subsidiaryChecked && (
                        <>
                          <Grid item md={3} sm={6} xs={12}>
                            <FormControl fullWidth className="dropDownLabel">
                              <InputLabel
                                id="select-subsidiary-label"
                                sx={{
                                  backgroundColor: "white",
                                  padding: "0 8px",
                                }}
                              >
                                Select Subsidiary
                              </InputLabel>
                              <Select
                                labelId="select-subsidiary-label"
                                id="select-subsidiary"
                                value={subsidiarySearchInputValue}
                                label="Select Subsidiary"
                                onChange={onCustomSubsidiaryInputSearch}
                                variant="outlined"
                                size="medium"
                                sx={{
                                  "& .MuiSelect-select": {
                                    paddingTop: "8px",
                                    paddingBottom: "8px",
                                    // backgroundColor: "white",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#ccc",
                                  },
                                }}
                              >
                                {subsdiaryRowData?.map((e) => {
                                  return (
                                    <MenuItem key={e.name} value={e.name}>
                                      {e.name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                      <Button
                        size="small"
                        type="button"
                        sx={{ color: "black", fontWeight: "600" }}
                        onClick={(e) => handleClickReset(e)}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <Grid container alignItems="center">
                  <Grid item md={1} sm={1} xs={1}>
                    <Button
                      id="basic-button1"
                      sx={{ color: "black", fontWeight: "600" }}
                      aria-controls={open1 ? "basic-menu1" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open1 ? "true" : undefined}
                      onClick={handleClick1}
                    >
                      <SearchIcon /> <KeyboardArrowDownIcon />
                    </Button>

                    <Menu
                      id="basic-menu1"
                      anchorEl={anchorEl}
                      open={open1}
                      MenuListProps={{
                        "aria-labelledby": "basic-button1",
                        style: {
                          maxHeight: "250px",
                          overflowY: "auto",
                        },
                      }}
                    >
                      {pageDetail?.title === "Vendor Bill List" && (
                        <MenuItem>
                          <Box>
                            {" "}
                            <Checkbox
                              name="vendor"
                              checked={vendorChecked}
                              ref={vendorRef}
                              onClick={handleClose1}
                            />
                            Vendor Name
                          </Box>
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              width: "100%",
                              position: "relative",
                              top: "-16px",
                              left: "5px",
                            }}
                          >
                            <svg
                              onClick={handleClose1}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              height={25}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </Box>
                        </MenuItem>
                      )}
                      <MenuItem>
                        <Box>
                          <Checkbox
                            name="date"
                            checked={dateChecked}
                            ref={dateRef}
                            onClick={handleClose1}
                          />
                          Date
                        </Box>
                        {pageDetail?.title === "Vendor Bill List" ? (
                          <></>
                        ) : (
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              width: "100%",
                              position: "relative",
                              top: "-16px",
                              left: "5px",
                            }}
                          >
                            <svg
                              onClick={handleClose1}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              height={25}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              ></path>
                            </svg>
                          </Box>
                        )}
                      </MenuItem>

                      {/* <MenuItem>
                      <Checkbox
                        name="memo"
                        checked={MemoChecked}
                        ref={MemoRef}
                        onClick={handleClose1}
                      />
                      Memo
                    </MenuItem> */}

                      {/* {pageDetail?.title !== "Bill Credit List" &&
                      pageDetail?.title !== "Bill Payment List" ? (
                        <MenuItem>
                          <Checkbox
                            name="documentno"
                            checked={docuChecked}
                            ref={docuRef}
                            onClick={handleClose1}
                          />
                          Document No.
                        </MenuItem>
                      ) : (
                        <></>
                      )} */}
                      {/* <MenuItem>
                      <Checkbox
                        name="internalid"
                        checked={idChecked}
                        ref={docuRef}
                        onClick={handleClose1}
                      />
                      View Id
                    </MenuItem> */}
                      {/* <MenuItem>
                      <Checkbox
                        name="name"
                        checked={customerChecked}
                        ref={customerRef}
                        onClick={handleClose1}
                      />
                      Name
                    </MenuItem> */}
                      {pageDetail?.title != "Vendor Bill List" &&
                        pageDetail?.title !== "Check" &&
                        pageDetail?.title !== "Expense Report" &&
                        pageDetail?.title !== "Item Fulfillment" &&
                        pageDetail?.title !== "Item Receipt" &&
                        pageDetail?.title !== "Purchase Order" &&
                        pageDetail?.title !== "Vendor Return Authorization" && (
                          <MenuItem>
                            <Checkbox
                              name="name"
                              checked={customerChecked}
                              ref={customerRef}
                              onClick={handleClose1}
                            />
                            {pageDetail?.title === "journal" ||
                            pageDetail?.title === "Bill Credit List" ||
                            pageDetail?.title === "Bill Payment List" ||
                            pageDetail?.title === "Credit Card Refund" ||
                            pageDetail?.title === "Credit Card"
                              ? "Name"
                              : "Customer"}
                          </MenuItem>
                        )}
                      <MenuItem>
                        <Checkbox
                          name="subsidiary_name"
                          checked={subsidiaryChecked}
                          ref={subsidiaryRef}
                          onClick={handleClose1}
                        />
                        Subsidiary Name
                      </MenuItem>
                      {pageDetail?.title === "Vendor Bill List" && (
                        <>
                        
                        <MenuItem>
                          <Checkbox
                            name="pc_project"
                            checked={pcProjectChecked}
                            ref={pcProjectRef}
                            onClick={handleClose1}
                          />
                          Pc/Project
                        </MenuItem>
                         <MenuItem>
                         <Checkbox
                           name="status"
                           checked={statusChecked}
                           ref={statusRef}
                           onClick={handleClose1}
                         />
                         Status
                       </MenuItem>
                       </>
                      )}
                      {pageDetail?.title === "Cash Sale" && (
                        <MenuItem>
                          <Checkbox
                            name="pc_project"
                            checked={pcProjectChecked}
                            ref={pcProjectRef}
                            onClick={handleClose1}
                          />
                          Pc/Project
                        </MenuItem>
                      )}
                      {(pageDetail?.title === "Journal" ||
                        pageDetail?.title === "Check" ||
                        pageDetail?.title === "Invoice") && (
                        <>
                          <MenuItem>
                            <Checkbox
                              name="pc_project"
                              checked={pcProjectChecked}
                              ref={pcProjectRef}
                              onClick={handleClose1}
                            />
                            Pc/Project
                          </MenuItem>
                          <MenuItem>
                            <Checkbox
                              name="account"
                              checked={accountChecked}
                              ref={accountRef}
                              onClick={handleClose1}
                            />
                            Account
                          </MenuItem>
                        </>
                      )}
                      {(pageDetail?.title === "Credit Card" ||
                        pageDetail?.title === "Credit Card Refund" ||
                        pageDetail?.title === "Credit Memo") && (
                        <>
                          <MenuItem>
                            <Checkbox
                              name="pc_project"
                              checked={pcProjectChecked}
                              ref={pcProjectRef}
                              onClick={handleClose1}
                            />
                            Pc/Project
                          </MenuItem>
                          <MenuItem>
                            <Checkbox
                              name="account"
                              checked={accountChecked}
                              ref={accountRef}
                              onClick={handleClose1}
                            />
                            Account
                          </MenuItem>
                        </>
                      )}
                      {(pageDetail?.title === "Deposit" ||
                        pageDetail?.title === "Customer Refund"||pageDetail?.title === "Transfer") && (
                        <>
                          <MenuItem>
                            <Checkbox
                              name="account"
                              checked={accountChecked}
                              ref={accountRef}
                              onClick={handleClose1}
                            />
                            Account
                          </MenuItem>
                        </>
                      )}
                      {/* <MenuItem>
                      <Checkbox
                        name="po_check_number"
                        checked={poCheckNumberChecked}
                        ref={poCheckNumberRef}
                        onClick={handleClose1}
                      />
                      PO Check Number
                    </MenuItem> */}

                      {/* <MenuItem>
                      <Checkbox
                        name="currency"
                        checked={currencyChecked}
                        ref={currencyRef}
                        onClick={handleClose1}
                      />
                      Currency
                    </MenuItem> */}
                      {(pageDetail?.title === "Item Fulfillment" || pageDetail?.title === "Item Receipt" || pageDetail?.title === "Vendor Return Authorization" ||  pageDetail?.title === "Purchase Order") && (
                        <>
                         <MenuItem>
                            <Checkbox
                              name="name"
                              checked={customerChecked}
                              ref={customerRef}
                              onClick={handleClose1}
                            />
                            Vendor
                          </MenuItem>
                          <MenuItem>
                            <Checkbox
                              name="pc_project"
                              checked={pcProjectChecked}
                              ref={pcProjectRef}
                              onClick={handleClose1}
                            />
                            Pc/Project
                          </MenuItem>
                         
                        </>
                      )}

                      {pageDetail?.title === "Expense Report" && (
                        <MenuItem>
                          <Checkbox
                            name="name"
                            checked={customerChecked}
                            ref={customerRef}
                            onClick={handleClose1}
                          />
                          Employee
                        </MenuItem>
                      )}
                     
                    </Menu>
                  </Grid>
                  <Grid
                    item
                    md={11}
                    sm={11}
                    xs={11}
                    alignItems="center"
                    display="flex"
                    flexWrap="wrap"
                  >
                    {/*  */}
                    {dateChecked && (
                      <>
                        <Box
                          style={{
                            display: "flex",
                            gap: "5px",
                            justifyItems: "center",
                            alignItems: "center",
                            marginRight: "8px",
                          }}
                        >
                          <div>
                            <DatePicker
                              selected={startDate}
                              onChange={handleStartDateChange}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="mm/dd/yyyy"
                              maxDate={today}
                              showIcon
                              showYearDropdown
                            />
                          </div>
                          to
                          <div>
                            <DatePicker
                              selected={endDate}
                              onChange={handleEndDateChange}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="mm/dd/yyyy"
                              maxDate={today}
                              showIcon
                              showYearDropdown
                            />
                          </div>
                        </Box>
                      </>
                    )}

                    {!dateChecked &&
                      !statusChecked &&
                      !MemoChecked &&
                      !idChecked &&
                      !customerChecked &&
                      !subsidiaryChecked &&
                      !poCheckNumberChecked &&
                      !vendorChecked &&
                      !currencyChecked &&
                      !accountChecked &&
                      !postingChecked &&
                      !pcProjectChecked &&
                      !ExpAccountChecked && (
                        <TextField
                          autoComplete="off"
                          type={dateChecked ? "date" : ""}
                          id="outlined-basic"
                          placeholder="Search Document No."
                          size="small"
                          label=""
                          name={dateChecked ? "datefrom" : ""}
                          variant="outlined"
                          value={searchInputValue}
                          onChange={InputSearch}
                          sx={{ pr: 1 }}
                        />
                      )}
                    {pcProjectChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${
                          pcProjectChecked ? "Search Pc/Project" : ""
                        }`}
                        size="small"
                        label=""
                        name={pcProjectChecked ? "pc_project" : ""}
                        variant="outlined"
                        value={pc_projectInputValue}
                        onChange={onPcProjectInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {ExpAccountChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${
                          ExpAccountChecked ? "Search Expense Account" : ""
                        }`}
                        size="small"
                        label=""
                        name={ExpAccountChecked ? "expense_account" : ""}
                        variant="outlined"
                        value={expense_accountInputValue}
                        onChange={onExpenseAccountInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {MemoChecked ? (
                      <TextField
                        autoComplete="off"
                        placeholder={MemoChecked ? "Memo" : ""}
                        size="small"
                        label=""
                        name={MemoChecked ? "Memo" : ""}
                        variant="outlined"
                        value={memoSearchInputValue}
                        onChange={onMemoInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    ) : (
                      <></>
                    )}
                    {/* {docuChecked ? (
                      <TextField
                        autoComplete="off"
                        placeholder={docuChecked ? "Document no." : ""}
                        size="small"
                        label=""
                        name={docuChecked ? "Document no." : ""}
                        variant="outlined"
                        value={documentNoSearchInputValue}
                        onChange={onDocumentNoInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                        inputProps={{
                          inputMode: "text",
                        }}
                      />
                    ) : (
                      <></>
                    )} */}
                     {statusChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${statusChecked ? "Search By Status" : ""}`}
                        size="small"
                        label=""
                        name={statusChecked ? "status" : ""}
                        variant="outlined"
                        value={statusSearchInputValue}
                        onChange={onStatusInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {idChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${idChecked ? "view id" : ""}`}
                        size="small"
                        label=""
                        name={idChecked ? "view id" : ""}
                        variant="outlined"
                        value={viewIdSearchInputValue}
                        onChange={onViewIdInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {customerChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${customerChecked ? "Name" : ""}`}
                        size="small"
                        label=""
                        name={customerChecked ? "Name" : ""}
                        variant="outlined"
                        value={customerSearchInputValue}
                        onChange={onCustomerInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {subsidiaryChecked && (
                      <>
                        <Grid item md={3} sm={6} xs={12}>
                          <FormControl
                            // sx={{ width: "300px" }}
                            fullWidth
                            className="dropDownLabel"
                          >
                            <InputLabel
                              id="select-subsidiary-label"
                              sx={{
                                backgroundColor: "white",
                                padding: "0 8px",
                              }}
                            >
                              Select Subsidiary
                            </InputLabel>
                            <Select
                              labelId="select-subsidiary-label"
                              id="select-subsidiary"
                              value={subsidiarySearchInputValue}
                              label="Select Subsidiary"
                              onChange={onSubsidiaryInputSearch}
                              variant="outlined"
                              size="medium"
                              sx={{
                                "& .MuiSelect-select": {
                                  paddingTop: "8px",
                                  paddingBottom: "8px",
                                  // backgroundColor: "white",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ccc",
                                },
                              }}
                            >
                              {subsdiaryRowData?.map((e) => {
                                return (
                                  <MenuItem key={e.name} value={e.name}>
                                    {e.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    {poCheckNumberChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${
                          poCheckNumberChecked ? "PO Check Number" : ""
                        }`}
                        size="small"
                        label=""
                        name={poCheckNumberChecked ? "PO Check Number" : ""}
                        variant="outlined"
                        value={poCheckNumberSearchInputValue}
                        onChange={onPoCheckNumberInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {vendorChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${vendorChecked ? "Vendor Name" : ""}`}
                        size="small"
                        label=""
                        name={vendorChecked ? "vendor" : ""}
                        variant="outlined"
                        value={vendorSearchInputValue}
                        onChange={onVendorInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {currencyChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${currencyChecked ? "Currency" : ""}`}
                        size="small"
                        label=""
                        name={currencyChecked ? "Currency" : ""}
                        variant="outlined"
                        value={currencySearchInputValue}
                        onChange={onCurrencyInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {accountChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${accountChecked ? "Account" : ""}`}
                        size="small"
                        label=""
                        name={accountChecked ? "Account" : ""}
                        variant="outlined"
                        value={accountSearchInputValue}
                        onChange={onAccountInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    {postingChecked && (
                      <TextField
                        autoComplete="off"
                        placeholder={`${postingChecked ? "Posting" : ""}`}
                        size="small"
                        label=""
                        name={postingChecked ? "Posting" : ""}
                        variant="outlined"
                        value={postingSearchInputValue}
                        onChange={onPostingInputSearch}
                        style={{ marginTop: "4px", marginBottom: "4px" }}
                        sx={{ pr: 1 }}
                      />
                    )}
                    <Button
                      size="small"
                      type="button"
                      sx={{ color: "black", fontWeight: "600" }}
                      onClick={(e) => handleClickReset(e)}
                    >
                      Reset
                    </Button>
                    {error && <p>{error}</p>}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
        <AgGridPaginatedPageNumberSearchTable
          getTableRows={getTransactionTypeDetailTableData}
          // columns={transactionTypeDetailSalesOrder}
          columns={
            params.slug === "sales-order"
              ? transactionTypeDetailSalesOrder
              : params.slug === "purchase-order"
              ? transactionTypeDetailPurchaseOrder
              : params.slug === "invoice"
              ? transactionTypeDetailInvoice
              : params.slug === "vendor-bill-list"
              ? transactionTypeDetailBill
              : params.slug === "credit-memo"
              ? transactionTypeCreditMemo
              : params.slug === "journal"
              ? transactionJournalTable
              : params.slug === "revenue-arrangement"
              ? transactionRevenueArrangementTable
              : params.slug === "deposit"
              ? transactionDepositTable
              : params.slug === "custom"
              ? transactionTypeCustom
              : params.slug === "bill-payment-list"
              ? transactionTypeBillPayment
              : params.slug === "bill-credit-list"
              ? transactionTypeBillCreditTable
              : params.slug === "check"
              ? transactionTypeCheck
              : params.slug === "credit-card-refund"
              ? transactionTypeCreditCardTable
              : params.slug === "cash-sale"
              ? transactionTypeCashsaleDetails
              : params.slug === "credit-card"
              ? transactionTypeCreditCardTable
              : params.slug === "item-fulfillment"||params.slug === "item-receipt"||params.slug === "vendor-return-authorization"
              ? transactionTypeItemFullfillmenttable
              : transactionTypeDetailOther
          }
          perPage={20}
          refreshCounter={tableRefreshCount}
          onSortChanged={onSortChanged}
          // onDocSortChanged={onDocSortChanged}
          onInputSearch={onInputSearch}
        />
      </Paper>
    </>
  );
}
